export function BuildRightClickDropDownAction(
  label = "",
  icon = null,
  fs = null,
  hasDividerAbove = false
) {
  var action = {};
  action["label"] = label;
  action["icon"] = icon;
  action["fs"] = fs;
  action["divider"] = hasDividerAbove;
  return action;
}
